/* RESPONSIBLE TEAM: team-automation-foundations */
import ApplicationAdapter from './application';
import Permission from 'embercom/models/permission';

export default ApplicationAdapter.extend({
  deleteRecord(_store, type, snapshot) {
    let {
      id,
      adapterOptions: { reassignments, skipValidation },
    } = snapshot;
    let url = this.buildURL(type.modelName, id, snapshot, 'deleteRecord');

    if (!reassignments && !skipValidation) {
      throw new Error('You need to include reassignment options for this request');
    }

    if (skipValidation) {
      return this.ajax(url, 'DELETE');
    }

    let options = { data: Permission.transformReassignments(reassignments) };
    return this.ajax(url, 'DELETE', options);
  },
});
